module.exports = __webpack_public_path__ + "static/media/pass-1-bw.5abd37bb.png";